import { useEffect, useState } from "react";

import { TextField } from "@king-ict/eupisi-ui/components";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import PermanentAndTemporaryResidence from "../../../../models/Integration/PermanentAndTemporaryResidence";

interface PermanentAndTemporaryResidenceDataProps {
  data: string;
}

export default function PermanentAndTemporaryResidenceData({
  data,
}: PermanentAndTemporaryResidenceDataProps) {
  const { t } = useTranslation();

  const [permanentAndTemporaryResidence, setPermanentAndTemporaryResidence] = useState<PermanentAndTemporaryResidence>();

  useEffect(() => {
    var residence: PermanentAndTemporaryResidence = JSON.parse(data);
    setPermanentAndTemporaryResidence(residence);
  }, [data]);

  return (
    <>
      <Row>
        <Col md={12}>
          {permanentAndTemporaryResidence?.PermanentResidence && (
            <TextField
              plaintext
              label={t("person.permanentResidence")}
              value={permanentAndTemporaryResidence.PermanentResidence}
            />
          )}

          {permanentAndTemporaryResidence?.TemporaryResidence && (
            <TextField
              plaintext
              label={t("person.teporaryResidence")}
              value={permanentAndTemporaryResidence.TemporaryResidence}
            />
          )}

          {permanentAndTemporaryResidence?.Citizenship && (
            <TextField
              plaintext
              label={t("person.citizenship")}
              value={permanentAndTemporaryResidence.Citizenship}
            />
          )}

          {permanentAndTemporaryResidence?.DateOfBirth && (
            <TextField
              plaintext
              label={t("person.dateOfBirth")}
              value={permanentAndTemporaryResidence.DateOfBirth}
            />
          )}
        </Col>
      </Row>
    </>
  );
}
